module.exports = __webpack_public_path__ + "static/media/Google.381e757a.svg";